export function getSlideMetadata(cb) {
  window.Office.context.document.getSelectedDataAsync(window.Office.CoercionType.SlideRange, function(asyncResult) {
    if (asyncResult.status === window.Office.AsyncResultStatus.Failed) {
      console.warn("Error", asyncResult.error.message)
    } else {
      console.log("Metadata for selected slide(s):", JSON.stringify(asyncResult.value.slides[0]))
      cb(asyncResult.value.slides[0])
    }
  })
}
